/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */

import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import customStyles from "../../../../../assets/styles/customStyles";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { Row, Col, Image, Space } from "antd";
import { checkComponentPermission, checkCRUDPermission, exportCommonFile } from '../../../../../helpers/utilities';
import { TextField } from "@mui/material";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { QueryListTable } from './QueryListTable';
import moment from 'moment';

export const ScheduleQuery = React.forwardRef((props, ref) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { createLoader } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const classes = customStyles();
    const { form, view, handleClose } = props;
    const dispatch = useDispatch();
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("updateTs");
    const [iconAnimation, setIconAnimation] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [apiGetList, setApiGetList] = useState([]);
    const [apiGetListAll, setApiGetListAll] = useState([]);
    const [skip, setSkip] = useState(0);
    const [selected, setSelected] = useState([]);

    const limit = 250;
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);

    const dispatchFilter = (form, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let details = {
            date: moment(form?.dataOfSchedule).format("YYYY-MM-DD")
        };

        if (form?.groupId) {
            details['customerGroupId'] = form?.groupId;
        }

        if (form?.customerId) {
            details['customerId'] = form?.customerId;
        }

        if (form?.workflowId) {
            details['workflowId'] = form?.workflowId;
        }

        if (form?.scheduleFrequencyId) {
            details['scheduleFrequencyId'] = form?.scheduleFrequencyId;
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'v1/schedules/customer-product-schedules/tomanualfetch',
            method: 'post',
            skip: 0,
            details: details
        });
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(form, sortBy, sortOrder, s);
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchSearchFilter(search);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchSearchFilter(search);
                }, 500);
            }
        }
    }, [search]);

    const dispatchSearchFilter = (search) => {
        let a = apiGetListAll;
        if (search !== '') {
            a = apiGetListAll?.filter((el) => {
                return (el?.customer?.name?.match(new RegExp(search, "i")) ||
                    el?.customer?.serialNo?.match(new RegExp(search, "i")) ||
                    el?.workflow?.name?.match(new RegExp(search, "i")) ||
                    el?.scheduleStatus?.match(new RegExp(search, "i")) ||
                    el?.scheduleStatus?.match(new RegExp(search, "i")) ||
                    el?.product?.productName?.match(new RegExp(search, "i")) ||
                    el?.product?.productId?.match(new RegExp(search, "i")) ||
                    el?.scheduleFrequency?.name?.match(new RegExp(search, "i")) ||
                    el?.unit?.name?.match(new RegExp(search, "i")))
            });
        }
        setApiGetList(a);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(form, sortBy, sortOrder);
    }

    useImperativeHandle(ref, () => ({
        dispatchFilter(form) {
            dispatchFilter(form);
        }
    }));

    useEffect(() => {
        if (view === 'schedule-query' && getList) {
            setApiGetList(getList);
            setApiGetListAll(getList);
        }
    }, [getList]);


    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        exportCommonFile(name, apiGetListAll, data, selected, extension);
    }

    const handleSchedule = () => {
        let data = apiGetListAll?.filter((el) => { return selected.find(e => el.id === e) });
        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: "v1/schedule-instance/customer-schedule-instances/manualschedule",
            title: "Manual Schedule",
            details: {
                date: moment(form?.dataOfSchedule).format('YYYY-MM-DD'),
                customerProductSchedules: data
            }
        });
    }

    return (
        <>
            <MainHeader {...props} img={SettingsImg} handleCloseClick={() => handleClose('schedule-list')}
                title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Schedule Query-Result', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Schedule Query-Result'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission(`Schedule Transactions`, 'Action', 'Schedule Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.customerLabelNone, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Schedule Transactions', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => loadImportExportData('Schedule Query-Result')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission(`Schedule Transactions`, 'Action', 'Cancel') &&
                                                <NavLink
                                                    to={'#'}
                                                    onClick={() => handleClose('schedule-list')}
                                                    className={clsx(classes.AddMoreBtn)}>
                                                    Cancel
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission(`Schedule Transactions`, 'create', 'Admin') && <>
                                                    {
                                                        selected && selected?.length > 0 && <NavLink
                                                            to={'#'}
                                                            onClick={() => handleSchedule()}
                                                            className={clsx(classes.modalBtn, { [classes.loadingA]: createLoader })}>
                                                            Schedule
                                                        </NavLink>
                                                    }
                                                </>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <QueryListTable
                                {...props}
                                selected={selected}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={apiGetList}
                                loadMore={loadMore}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                handleSelected={(value) => setSelected(value)}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                            />
                        </>
                    }
                />
            </div>
        </>
    )
})